exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".manifest-label {\n  margin: 2px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/kubernetes/src/v2/manifest/manifestLabels.less
// module id = 3870
// module chunks = 0